/**
 * ThemeSwitcher — floating card wrapping ThemeSelector (premium chrome).
 */
'use client'

import React from 'react'
import { Card } from 'antd'
import { useTheme } from '@/shared/theme/provider/ThemeProvider'
import { ThemeSelector } from '@/shared/theme/components/ThemeSelector'
import { getThemeCatalogEntry } from '@/shared/theme/catalog'

export function ThemeSwitcher() {
  const { isDark, colorTheme, token } = useTheme()
  const entry = getThemeCatalogEntry(colorTheme)

  return (
    <Card
      title={
        <span style={{ color: token.colorText, fontWeight: 600 }}>
          Desk · {entry.name}
        </span>
      }
      style={{
        position: 'absolute',
        top: 20,
        right: 20,
        zIndex: 1000,
        width: 400,
        maxWidth: 'calc(100vw - 32px)',
        background: isDark
          ? `color-mix(in srgb, ${token.colorBgElevated} 88%, transparent)`
          : `color-mix(in srgb, ${token.colorBgElevated} 92%, transparent)`,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: 12,
        boxShadow: token.boxShadowSecondary ?? token.boxShadow,
        backdropFilter: 'blur(16px) saturate(1.15)',
      }}
      styles={{
        header: {
          borderBottom: `1px solid ${token.colorBorderSecondary}`,
          background: 'transparent',
          minHeight: 48,
        },
        body: { padding: 16, background: 'transparent', border: 'none' },
      }}
    >
      <ThemeSelector variant="compact" showMode showDescription={false} />
    </Card>
  )
}

export default ThemeSwitcher
